module.exports = "/_next/static/images/23365ee8ed7588dcc6e2f3a99ec58265-question.svg";